import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import { userDate, formatYearMonth } from 'owa-datetime';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';

import * as styles from './styles.scss';

export interface CalendarSearchHeaderProps {
    item: SearchResultItem;
}

export default observer(function CalendarSearchHeader(props: CalendarSearchHeaderProps) {
    const { item } = props;
    const calendarItem = item.data as CalendarItem;

    const date = userDate(calendarItem.Start || '');

    return <div className={styles.calendarSearchHeader}>{formatYearMonth(date)}</div>;
});
